import { render, staticRenderFns } from "./LocatieInformatieUploadAttachment.vue?vue&type=template&id=61430926&"
import script from "./LocatieInformatieUploadAttachment.vue?vue&type=script&lang=js&"
export * from "./LocatieInformatieUploadAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports